export default __webpack_public_path__ + "static/media/TurboTax_Transparent.2c115e91.png";